export const STRUTTURA_CONFIG = {
  zohoId: null,
  nome: "Struttura",
  telefono: "",
  email: "",
  referente_nome: "",
  referente_telefono: "",
  ragione_sociale: "",
  partita_iva: "",
  codice_fiscale: "",
  indirizzo: "",
  cap: "",
  citta: "",
  provincia: "",
  comune: "",
  tipologia: "",
  config: {
    moduli_abilitati: [
      "dashboard",
      "cartelle-cliniche",
      "alloggiati-web", 
      "posti-liberi",
      "ospiti-in-rete",
      "immobiliare",
      "personale",
      "risparmio",
      "newsletter"
    ],
    tema: "default",
    refresh_interval: 30
  }
};

/**
 * Update struttura config. Accepts either:
 * - A struttura object from the strutture list (has zohoRecordId, name)
 * - A legacy user object (has struttura_id, facility_name)
 * - null to reset
 */
export const updateStrutturaConfig = (data) => {
  if (!data) {
    STRUTTURA_CONFIG.zohoId = null;
    STRUTTURA_CONFIG.nome = "Struttura";
    return;
  }

  // Preferire id nativo Affidya; zohoRecordId solo come fallback legacy
  STRUTTURA_CONFIG.zohoId =
    data.struttura_id || data.id || data.activeStrutturaId || data.zohoRecordId || null;
  // Preferire facility_name (nome struttura) su name, così per utenti mono-struttura
  // non si mostra il nome utente (user.name) ma quello della struttura (user.facility_name)
  STRUTTURA_CONFIG.nome = data.facility_name || data.name || "Struttura";
};

export const getSaluto = () => {
  const ora = new Date().getHours();
  
  if (ora >= 5 && ora < 12) {
    return "Buongiorno";
  } else if (ora >= 12 && ora < 18) {
    return "Buon pomeriggio";
  } else {
    return "Buonasera";
  }
};

export const getWelcomeMessage = () => {
  return `${getSaluto()}, ${STRUTTURA_CONFIG.nome}`;
};

export default STRUTTURA_CONFIG;
